document.addEventListener('DOMContentLoaded', function () {
  const drawer = document.querySelector('[data-siafu-filter-drawer]');
  const backdrop = document.querySelector('[data-siafu-filter-backdrop]');
  const openButton = document.querySelector('[data-siafu-open-filters]');
  const closeButton = document.querySelector('[data-siafu-close-filters]');
  const sortSelects = document.querySelectorAll('[data-siafu-sort]');

  function openDrawer() {
    if (!drawer || !backdrop) return;

    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    backdrop.hidden = false;
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    if (!drawer || !backdrop) return;

    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    backdrop.hidden = true;
    document.body.style.overflow = '';
  }

  if (openButton) {
    openButton.addEventListener('click', openDrawer);
  }

  if (closeButton) {
    closeButton.addEventListener('click', closeDrawer);
  }

  if (backdrop) {
    backdrop.addEventListener('click', closeDrawer);
  }

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeDrawer();
    }
  });

  sortSelects.forEach(function (select) {
    select.addEventListener('change', function () {
      const url = new URL(window.location.href);

      url.searchParams.set('sort_by', this.value);
      url.searchParams.delete('page');

      window.location.href = url.toString();
    });
  });
});